const tenant = process.env.REACT_APP_B2C_TENANT || "your-tenant";
const clientId = process.env.REACT_APP_B2C_CLIENT_ID || "00000000-0000-0000-0000-000000000000";
const signInPolicy = process.env.REACT_APP_B2C_POLICY_SIGNUP_SIGNIN || "B2C_1_signupsignin";
const passwordResetPolicy = process.env.REACT_APP_B2C_POLICY_PASSWORDRESET || "";
const editProfilePolicy = process.env.REACT_APP_B2C_POLICY_EDITPROFILE || "";
const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin;
const apiScope = process.env.REACT_APP_B2C_API_SCOPE || `api://${clientId}/access`;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://localhost:5001";
const graphScope = process.env.REACT_APP_GRAPH_SCOPE || "https://graph.microsoft.com/User.ReadWrite";
const graphBaseUrl = process.env.REACT_APP_GRAPH_BASE_URL || "https://graph.microsoft.com/v1.0";
// Allow a shared override used by hosted shared components; fall back to app-specific override.
const authorityOverride = process.env.REACT_APP_SHARED_AUTHORITY || process.env.REACT_APP_AUTHORITY || "";

// idpType lets us switch between classic Azure AD B2C (b2clogin.com) and Microsoft Entra External ID for customers (ciamlogin.com)
const idpType = (process.env.REACT_APP_IDP_TYPE || "ciam").toLowerCase();

// Build a default authority if not overridden. CIAM/B2C both support a simple v2.0 authority with tenantId; B2C also supports policy-based authorities.
let authority = "";
if (authorityOverride) {
  authority = authorityOverride;
} else {
  const authorityDomain = idpType === "b2c" ? `${tenant}.b2clogin.com` : `${tenant}.ciamlogin.com`;

  // If a sign-in policy is provided, use the policy-style authority (B2C). Otherwise fall back to tenant-only v2.0 authority (CIAM-style).
  const path = signInPolicy
    ? `${tenant}.onmicrosoft.com/${signInPolicy}`
    : tenant; // CIAM often uses tenant GUID here

  authority = `https://${authorityDomain}/${path}`;
}

// knownAuthorities should be the host only
const authorityHost = authority.split("//")[1]?.split("/")[0];

export const msalConfig = {
  auth: {
    clientId,
    authority,
    knownAuthorities: authorityHost ? [authorityHost] : [],
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const protectedResources = {
  api: {
    scopes: [apiScope],
    baseUrl: apiBaseUrl,
  },
};

export const graphConfig = {
  scopes: [graphScope],
  baseUrl: graphBaseUrl,
};

export const loginRequest = {
  scopes: protectedResources.api.scopes,
  authority,
};

const policyAuthority = (policy) => {
  if (!policy) return "";
  if (authorityOverride) return authorityOverride; // override wins
  const authorityDomain = idpType === "b2c" ? `${tenant}.b2clogin.com` : `${tenant}.ciamlogin.com`;
  return `https://${authorityDomain}/${tenant}.onmicrosoft.com/${policy}`;
};

export const passwordResetRequest = passwordResetPolicy
  ? {
      scopes: protectedResources.api.scopes,
      authority: policyAuthority(passwordResetPolicy),
    }
  : null;

export const editProfileRequest = editProfilePolicy
  ? {
      scopes: protectedResources.api.scopes,
      authority: policyAuthority(editProfilePolicy),
    }
  : null;
